require('./app.scss')

module.exports =
  template: require('./app.pug')()
  controller: require './app.ctrl'

